/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Book_Projects_TitleInputs */

const en_book_projects_title = /** @type {(inputs: Book_Projects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book Projects`)
};

const es_book_projects_title = /** @type {(inputs: Book_Projects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyectos de Libros`)
};

const fr_book_projects_title = /** @type {(inputs: Book_Projects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projets de Livres`)
};

const de_book_projects_title = /** @type {(inputs: Book_Projects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchprojekte`)
};

const ja_book_projects_title = /** @type {(inputs: Book_Projects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブックプロジェクト`)
};

const zh_book_projects_title = /** @type {(inputs: Book_Projects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图书项目`)
};

const ar_book_projects_title = /** @type {(inputs: Book_Projects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشاريع الكتب`)
};

const id_book_projects_title = /** @type {(inputs: Book_Projects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyek Buku`)
};

const it_book_projects_title = /** @type {(inputs: Book_Projects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetti Libro`)
};

const ru_book_projects_title = /** @type {(inputs: Book_Projects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проекты Книг`)
};

const pt_book_projects_title = /** @type {(inputs: Book_Projects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projetos de Livros`)
};

const ko_book_projects_title = /** @type {(inputs: Book_Projects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`책 프로젝트`)
};

/**
* | output |
* | --- |
* | "Book Projects" |
*
* @param {Book_Projects_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const book_projects_title = /** @type {((inputs?: Book_Projects_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Book_Projects_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_book_projects_title(inputs)
	if (locale === "es") return es_book_projects_title(inputs)
	if (locale === "fr") return fr_book_projects_title(inputs)
	if (locale === "de") return de_book_projects_title(inputs)
	if (locale === "ja") return ja_book_projects_title(inputs)
	if (locale === "zh") return zh_book_projects_title(inputs)
	if (locale === "ar") return ar_book_projects_title(inputs)
	if (locale === "id") return id_book_projects_title(inputs)
	if (locale === "it") return it_book_projects_title(inputs)
	if (locale === "ru") return ru_book_projects_title(inputs)
	if (locale === "pt") return pt_book_projects_title(inputs)
	return ko_book_projects_title(inputs)
});